export class StudentAttachment {
  DocumentId: number;
  DocumentName: string;
  DocumentBase64: string;
  DocumentMimeType: string;
  DocumentModuleName: string;
  ReportParameters = [];
  ReportType: number;
}
